import { useState } from "react";
import {
    Button,
    Popover,
    PopoverHandler,
    PopoverContent,
    Card,
    CardHeader,
    CardBody,
    Typography,
} from "@material-tailwind/react";
import { PlusCircleIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomRFQCreate from "./rfq-modals/create-custom-rfq-modal";

export default function RfqTypeSelector() {
    const [open, setOpen] = useState(false);
    const [isCustomRfqModalOpen, setIsCustomRfqModalOpen] = useState(false);
    const { t } = useTranslation('rfq');
    const { t: ct } = useTranslation("common");

    return (
        <div>
            <Popover open={open} handler={setOpen} placement="bottom-end">

                {/* Trigger Button */}
                <PopoverHandler>
                    <Button
                        variant="outlined"
                        className="flex items-center gap-2 border-gray-300 bg-black text-white font-normal capitalize"
                    >
                        <PlusCircleIcon className="w-4 h-4" /> {t("create_rfq_button")}
                    </Button>
                </PopoverHandler>

                {/* Popover Content */}
                <PopoverContent className="w-80 p-5 rounded-2xl shadow-xl bg-white border border-gray-200 z-[100]">
                    <div className="space-y-4">

                        <Typography variant="small" color="blue-gray" className="mb-2 font-medium">
                            {t("choose_rfq_type")}
                        </Typography>

                        {/* RFQ Options */}
                        <div className="flex flex-col gap-3">

                            <Link to="/dashboard/products">
                                <Button
                                    type="button"
                                    variant="outlined"
                                    className="rounded-lg w-full flex items-center gap-2 justify-center border-gray-300 capitalize font-bold"
                                >
                                    <PlusCircleIcon className="w-4 h-4" /> {t("normal_rfq_tab")}
                                </Button>
                            </Link>

                            <Link>
                                <Button
                                    onClick={() => setIsCustomRfqModalOpen(true)}
                                    type="submit"
                                    className="w-full flex items-center gap-2 justify-center border-gray-300 capitalize font-bold bg-black text-white">
                                    <PlusCircleIcon className="w-4 h-4" /> {t("custom_rfq_tab")}
                                </Button>
                            </Link>

                        </div>

                        {/* Divider */}
                        <div className="border-t border-gray-200"></div>

                        {/* Note */}
                        <div className="p-3 bg-gray-50 rounded-xl border text-sm text-gray-700 leading-relaxed">
                            <strong className="font-semibold text-red-600">{ct("note")}:</strong>{" "}
                            {t("add_customer_note")}

                            <Link
                                to="/dashboard/customers/add"
                                className="flex items-center mt-2 text-blue-600 font-medium hover:underline"
                            >
                                {t("create_customer_link")} <ArrowRightIcon className="w-4 h-4 ml-1" />
                                {/* Create Customer <ArrowRightIcon className="w-4 h-4 ml-1" /> */}
                            </Link>
                        </div>

                    </div>
                </PopoverContent>
            </Popover>
            {isCustomRfqModalOpen && < CustomRFQCreate onClose={() => setIsCustomRfqModalOpen(false)}></CustomRFQCreate>}
        </div>
    );
}
